function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Button } from "./Button";
export function ChevronUpButton(_ref) {
  let {
    iconStyles,
    iconClassName,
    ...props
  } = _ref;
  iconStyles = {
    width: '2rem',
    height: '2rem',
    ...iconStyles
  };
  const defaultIconClassName = "text-primary rounded-circle mx-auto";
  const passedIconClassName = iconClassName ? iconClassName : defaultIconClassName;
  return /*#__PURE__*/React.createElement(Button, _extends({
    variant: "light",
    className: "p-1 d-inline-flex rounded-circle"
  }, props, {
    iconStyles: iconStyles,
    icon: "expand_less",
    iconClassName: passedIconClassName
  }));
}
;